import React from 'react';

import { IconButton, styled } from '@mui/material';
import MaterialGrid from '@mui/material/Grid/Grid';

import { useEventEmitter } from '@ezbobdev/ui-commons';
import { useTranslation } from '@ezbobdev/ui-framework';

import MaterialLink from '../../MaterialLink/MaterialLink';
import MaterialTypography from '../../MaterialTypography/MaterialTypography';

// TODO: The text should be moved out of IconButton to inherit color properly
const StyledMaterialTypography = styled(MaterialTypography)`
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const HelpPopoverContent = (props) => {
  const {
    iconSrc,
    configByName,
    phoneIconSrc,
    mailIconSrc,
    declarationLink,
    handlePhonePopoverOpen,
    onFormIconClick,
    onQnAIconClick,
    QnAIconSrc,
  } = props;

  const { t, i18n } = useTranslation();
  const { emitEvent } = useEventEmitter();

  const handlePhoneIconClick = (e) => {
    emitEvent(e.type, { label: t(`${configByName}.help.popover.phoneIconDescription`) });
    handlePhonePopoverOpen();
  };

  const handleQandAIconClick = (e) => {
    emitEvent(e.type, { label: t(`${configByName}.help.popover.QnAIconDescription`) });
    onQnAIconClick();
  };

  const handleMailIconClick = (e) => {
    emitEvent(e.type, { label: t(`${configByName}.help.popover.mailIconDescription`) });
    onFormIconClick();
  };

  return (
    <>
      <MaterialGrid justifyContent="center" display="flex" item>
        <img src={iconSrc} alt={t(`${configByName}.help.popover.iconAlt`)} />
      </MaterialGrid>

      <MaterialGrid item>
        <MaterialTypography align="center" variant="h2">
          {t(`${configByName}.help.popover.title`)}
        </MaterialTypography>
      </MaterialGrid>

      <MaterialGrid display="flex" justifyContent="space-between" item container>
        <IconButton className="helpPopoverButton" disableRipple onClick={handlePhoneIconClick}>
          <img src={phoneIconSrc} alt={t(`${configByName}.help.popover.phoneIconAlt`)} />
          <StyledMaterialTypography align="center" variant="body2">
            {t(`${configByName}.help.popover.phoneIconDescription`)}
          </StyledMaterialTypography>
        </IconButton>

        <IconButton className="helpPopoverButton" disableRipple onClick={handleMailIconClick}>
          <img src={mailIconSrc} alt={t(`${configByName}.help.popover.mailIconAlt`)} />
          <StyledMaterialTypography align="center" variant="body2">
            {t(`${configByName}.help.popover.mailIconDescription`)}
          </StyledMaterialTypography>
        </IconButton>

        <IconButton className="helpPopoverButton" disableRipple onClick={handleQandAIconClick}>
          <img src={QnAIconSrc} alt={t(`${configByName}.help.popover.QnAIconAlt`)} />
          <StyledMaterialTypography align="center" variant="body2">
            {t(`${configByName}.help.popover.QnAIconDescription`)}
          </StyledMaterialTypography>
        </IconButton>
      </MaterialGrid>

      {declarationLink && i18n.exists(`${configByName}.help.popover.declarationLinkText`) && (
        <MaterialGrid justifyContent="center" display="flex" item sx={{ mt: 4, mb: 5, fontWeight: 500 }}>
          <MaterialLink href={declarationLink} target="_blank">
            {t(`${configByName}.help.popover.declarationLinkText`)}
            <MaterialTypography srOnly>{t('globals.opensInNewTab')}</MaterialTypography>
          </MaterialLink>
        </MaterialGrid>
      )}
    </>
  );
};
